function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useCallback, useEffect, useRef, useState } from 'react';
import { Alert, Badge, Button, Form, Modal } from 'react-bootstrap';
import GoogleMapCanvas from './GoogleMapCanvas';
import TrackingDetails, { statusText, distanceText, durationText, arrivalText } from './TrackingDetails';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var reasons = {
  GPS_UNAVAILABLE: 'Waiting for a fresh driver GPS update. Live ETA is unavailable.',
  NO_API_KEY: 'Traffic routing is not configured. Use Open navigation for Google Maps directions.',
  LOOKUP_FAILED: 'Google could not calculate this route. Retry or use Open navigation.',
  INSUFFICIENT_ADDRESS: 'Some stops have no saved address. Ask the transport desk to update pickup/drop locations.',
  TOO_MANY_STOPS: 'This run exceeds the route lookup stop limit. Ask the transport desk to split the run.'
};
var pointText = a => (a === null || a === void 0 ? void 0 : a.lat) != null && (a === null || a === void 0 ? void 0 : a.lng) != null ? "".concat(a.lat, ",").concat(a.lng) : (a === null || a === void 0 ? void 0 : a.label) || (a === null || a === void 0 ? void 0 : a.formatted) || '';
export function navigationUrl(destination, origin) {
  var url = new URL('https://www.google.com/maps/dir/');
  url.searchParams.set('api', '1');
  url.searchParams.set('travelmode', 'driving');
  url.searchParams.set('dir_action', 'navigate');
  url.searchParams.set('destination', pointText(destination));
  if (pointText(origin)) url.searchParams.set('origin', pointText(origin));
  return url.toString();
}
export default function TrackingDashboard(_ref) {
  var _displayedRoute$stops, _current$location, _current$location2;
  var client = _ref.client,
    vertical = _ref.vertical,
    apiKey = _ref.apiKey,
    mapId = _ref.mapId;
  var _useState = useState(Date.now()),
    _useState2 = _slicedToArray(_useState, 2),
    clock = _useState2[0],
    setClock = _useState2[1];
  var _useState3 = useState(navigator.onLine === false),
    _useState4 = _slicedToArray(_useState3, 2),
    offline = _useState4[0],
    setOffline = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    notice = _useState6[0],
    setNotice = _useState6[1];
  var previousAssignment = useRef(null);
  var sharingAssignment = useRef(null);
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    filter = _useState8[0],
    setFilter = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    routeLoading = _useState0[0],
    setRouteLoading = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    open = _useState10[0],
    setOpen = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    data = _useState12[0],
    setData = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    error = _useState14[0],
    setError = _useState14[1];
  var _useState15 = useState(''),
    _useState16 = _slicedToArray(_useState15, 2),
    selected = _useState16[0],
    setSelected = _useState16[1];
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    route = _useState18[0],
    setRoute = _useState18[1];
  var _useState19 = useState(''),
    _useState20 = _slicedToArray(_useState19, 2),
    routeError = _useState20[0],
    setRouteError = _useState20[1];
  var _useState21 = useState(0),
    _useState22 = _slicedToArray(_useState21, 2),
    revision = _useState22[0],
    setRevision = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    optimize = _useState24[0],
    setOptimize = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    sharing = _useState26[0],
    setSharing = _useState26[1];
  var _useState27 = useState(''),
    _useState28 = _slicedToArray(_useState27, 2),
    gpsMessage = _useState28[0],
    setGpsMessage = _useState28[1];
  var sending = useRef(false);
  var lastSent = useRef(0);
  var _useState29 = useState(apiKey ? {
      apiKey,
      mapId
    } : null),
    _useState30 = _slicedToArray(_useState29, 2),
    mapConfig = _useState30[0],
    setMapConfig = _useState30[1];
  useEffect(() => {
    if (!open || apiKey) return undefined;
    var stopped = false;
    client.get('/api/maps/browser-config').then(res => {
      var _res$data, _res$data2;
      if (!stopped) setMapConfig({
        apiKey: ((_res$data = res.data) === null || _res$data === void 0 || (_res$data = _res$data.data) === null || _res$data === void 0 ? void 0 : _res$data.apiKey) || '',
        mapId: mapId || ((_res$data2 = res.data) === null || _res$data2 === void 0 || (_res$data2 = _res$data2.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.mapId) || ''
      });
    }).catch(() => {
      if (!stopped) setMapConfig({
        apiKey: '',
        mapId
      });
    });
    return () => {
      stopped = true;
    };
  }, [open, apiKey, mapId, client, revision]);
  useEffect(() => {
    if (!open) return undefined;
    setClock(Date.now());
    var timer = setInterval(() => setClock(Date.now()), 15000);
    return () => clearInterval(timer);
  }, [open]);
  useEffect(() => {
    if (!open) return undefined;
    var disconnected = () => setOffline(true);
    var connected = () => {
      setOffline(false);
      setRevision(n => n + 1);
    };
    window.addEventListener('offline', disconnected);
    window.addEventListener('online', connected);
    return () => {
      window.removeEventListener('offline', disconnected);
      window.removeEventListener('online', connected);
    };
  }, [open]);
  var root = "/api/".concat(vertical, "/tracking");
  var nodes = ((data === null || data === void 0 ? void 0 : data.nodes) || []).map(n => _objectSpread(_objectSpread({}, n), {}, {
    location: n.location ? _objectSpread(_objectSpread({}, n.location), {}, {
      stale: n.location.stale || clock - new Date(n.location.at).getTime() > 120000
    }) : null
  }));
  var current = nodes.find(n => "".concat(n.kind, ":").concat(n.id) === selected);
  var visible = nodes.filter(n => "".concat(n.label, " ").concat(n.driverName || '', " ").concat(n.status, " ").concat(statusText(n.status), " ").concat(n.id).toLowerCase().includes(filter.toLowerCase()));
  var routeStale = (route === null || route === void 0 ? void 0 : route.status) === 'OK' && (clock - new Date(route.computedAt).getTime() > 90000 || current && (!current.location || current.location.stale));
  var displayedRoute = routeStale || offline || error ? null : route;
  useEffect(() => {
    var previous = previousAssignment.current;
    if ((previous === null || previous === void 0 ? void 0 : previous.id) === selected && current && (previous.key !== current.assignmentKey || previous.live !== current.liveEnabled)) {
      setSharing(false);
      setRoute(null);
      setNotice(previous.live && !current.liveEnabled ? 'Live tracking is no longer included for this trip. Location sharing has stopped.' : 'The assigned driver or cab changed. Location sharing has stopped; review the updated trip.');
    }
    previousAssignment.current = current ? {
      id: selected,
      key: current.assignmentKey,
      live: current.liveEnabled
    } : null;
  }, [selected, current === null || current === void 0 ? void 0 : current.assignmentKey, current === null || current === void 0 ? void 0 : current.liveEnabled]);
  useEffect(() => {
    if (sharing && !(current !== null && current !== void 0 && current.canShare)) setSharing(false);
    if (data && selected && !current) {
      setNotice('This trip is no longer in your assignments or plan. Location sharing has stopped.');
      setSelected('');
      setSharing(false);
      setRoute(null);
    }
  }, [data, selected, current, sharing]);
  useEffect(() => {
    if (!open) return undefined;
    var stopped = false;
    var timer;
    var shouldPoll = false;
    var abort = new AbortController();
    function load() {
      return _load.apply(this, arguments);
    }
    function _load() {
      _load = _asyncToGenerator(function* () {
        try {
          var res = yield client.get(root, {
            signal: abort.signal
          });
          if (!stopped) {
            setData(res.data.data);
            setError('');
            shouldPoll = res.data.data.nodes.some(n => n.liveEnabled);
          }
        } catch (e) {
          if (!stopped) {
            var _e$response;
            if ([401, 403].includes((_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.status)) {
              setData(null);
              shouldPoll = false;
            }
            setError('Live updates failed. Displayed locations may be out of date. Refresh to retry.');
          }
        } finally {
          if (!stopped && shouldPoll) timer = setTimeout(load, 15000);
        }
      });
      return _load.apply(this, arguments);
    }
    load();
    return () => {
      stopped = true;
      abort.abort();
      clearTimeout(timer);
    };
  }, [open, root, client, revision]);
  useEffect(() => {
    setRoute(null);
    setRouteError('');
    setRouteLoading(false);
    if (!open || !selected || !(current !== null && current !== void 0 && current.liveEnabled)) return undefined;
    var stopped = false;
    var timer;
    var abort = new AbortController();
    var _selected$split = selected.split(':'),
      _selected$split2 = _slicedToArray(_selected$split, 2),
      kind = _selected$split2[0],
      id = _selected$split2[1];
    setRouteLoading(true);
    function load() {
      return _load2.apply(this, arguments);
    }
    function _load2() {
      _load2 = _asyncToGenerator(function* () {
        try {
          var res = yield client.get("".concat(root, "/").concat(kind, "/").concat(id, "/route"), {
            params: {
              optimize
            },
            signal: abort.signal
          });
          if (!stopped) {
            setRoute(res.data.data);
            setRouteError('');
          }
        } catch (e) {
          if (!stopped) {
            var _e$response2;
            setRoute(null);
            setRouteError(((_e$response2 = e.response) === null || _e$response2 === void 0 || (_e$response2 = _e$response2.data) === null || _e$response2 === void 0 ? void 0 : _e$response2.msg) || 'Route update failed. ETA is unavailable.');
          }
        } finally {
          if (!stopped) {
            setRouteLoading(false);
            timer = setTimeout(load, 30000);
          }
        }
      });
      return _load2.apply(this, arguments);
    }
    load();
    return () => {
      stopped = true;
      clearTimeout(timer);
      abort.abort();
    };
  }, [open, selected, current === null || current === void 0 ? void 0 : current.liveEnabled, current === null || current === void 0 ? void 0 : current.status, current === null || current === void 0 ? void 0 : current.nextTarget, current === null || current === void 0 ? void 0 : current.cabId, current === null || current === void 0 ? void 0 : current.driverName, current === null || current === void 0 ? void 0 : current.assignmentKey, optimize, root, client, revision]);
  useEffect(() => {
    if (!sharing || !open || offline || !(current !== null && current !== void 0 && current.canShare) || sharingAssignment.current !== (current === null || current === void 0 ? void 0 : current.assignmentKey)) return undefined;
    if (!navigator.geolocation) {
      setGpsMessage('This browser cannot share GPS.');
      setSharing(false);
      return undefined;
    }
    var stopped = false;
    var watcher = navigator.geolocation.watchPosition(/*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* (position) {
        if (stopped || sending.current || Date.now() - lastSent.current < 10000) return;
        sending.current = true;
        lastSent.current = Date.now();
        try {
          yield client.post("".concat(root, "/").concat(current.kind, "/").concat(current.id, "/location"), {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            accuracyMeters: position.coords.accuracy
          });
          if (!stopped) setGpsMessage("Location shared at ".concat(new Date().toLocaleTimeString(), ". Keep this window open during the trip."));
        } catch (e) {
          if (!stopped) {
            var _e$response3, _e$response4;
            setGpsMessage(((_e$response3 = e.response) === null || _e$response3 === void 0 || (_e$response3 = _e$response3.data) === null || _e$response3 === void 0 ? void 0 : _e$response3.msg) || 'GPS upload failed.');
            if ([403, 409].includes((_e$response4 = e.response) === null || _e$response4 === void 0 ? void 0 : _e$response4.status)) setSharing(false);
          }
        } finally {
          sending.current = false;
        }
      });
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), e => {
      if (!stopped) {
        setGpsMessage(e.code === 1 ? 'Location permission was denied. Enable it in your browser to share trip GPS.' : 'GPS signal is unavailable. Check device location settings.');
        if (e.code === 1) setSharing(false);
      }
    }, {
      enableHighAccuracy: true,
      maximumAge: 10000,
      timeout: 15000
    });
    return () => {
      stopped = true;
      navigator.geolocation.clearWatch(watcher);
    };
  }, [sharing, open, offline, current === null || current === void 0 ? void 0 : current.id, current === null || current === void 0 ? void 0 : current.kind, current === null || current === void 0 ? void 0 : current.canShare, current === null || current === void 0 ? void 0 : current.assignmentKey, root, client]);
  var choose = useCallback(node => {
    setSharing(false);
    setGpsMessage('');
    setNotice('');
    setOptimize(false);
    setSelected("".concat(node.kind, ":").concat(node.id));
  }, []);
  var destination = (displayedRoute === null || displayedRoute === void 0 || (_displayedRoute$stops = displayedRoute.stops) === null || _displayedRoute$stops === void 0 || (_displayedRoute$stops = _displayedRoute$stops[0]) === null || _displayedRoute$stops === void 0 ? void 0 : _displayedRoute$stops.address) || ((current === null || current === void 0 ? void 0 : current.kind) === 'order' || (current === null || current === void 0 ? void 0 : current.nextTarget) === 'drop' || ['PICKED_UP', 'IN_TRANSIT'].includes(current === null || current === void 0 ? void 0 : current.status) ? current === null || current === void 0 ? void 0 : current.drop : current === null || current === void 0 ? void 0 : current.pickup) || (current === null || current === void 0 ? void 0 : current.drop);
  return /*#__PURE__*/_jsxs("div", {
    className: "my-3",
    children: [/*#__PURE__*/_jsx(Button, {
      onClick: () => setOpen(true),
      children: "Open live tracking map"
    }), /*#__PURE__*/_jsxs(Modal, {
      show: open,
      onHide: () => {
        setOpen(false);
        setSharing(false);
      },
      size: "xl",
      fullscreen: "md-down",
      scrollable: true,
      children: [/*#__PURE__*/_jsx(Modal.Header, {
        closeButton: true,
        style: {
          overflowWrap: "anywhere"
        },
        children: /*#__PURE__*/_jsx(Modal.Title, {
          children: "Trip maps & navigation"
        })
      }), /*#__PURE__*/_jsxs(Modal.Body, {
        style: {
          overflowWrap: "anywhere"
        },
        children: [/*#__PURE__*/_jsx("p", {
          children: "Professional includes the latest reported location and navigation. Premium adds live GPS, automatic updates, traffic ETA and remaining routes. Grey nodes indicate stale GPS."
        }), offline && /*#__PURE__*/_jsx(Alert, {
          variant: "warning",
          children: "You are offline. GPS uploads are paused and live arrival estimates are unavailable. Reconnect to resume updates."
        }), notice && /*#__PURE__*/_jsx("p", {
          role: "status",
          children: notice
        }), error && /*#__PURE__*/_jsx(Alert, {
          variant: "danger",
          children: error
        }), /*#__PURE__*/_jsx(Button, {
          variant: "outline-secondary",
          size: "sm",
          onClick: () => setRevision(n => n + 1),
          children: "Refresh tracking"
        }), !data && !error && /*#__PURE__*/_jsx("p", {
          role: "status",
          className: "mt-2",
          children: "Loading your assigned trips..."
        }), data && /*#__PURE__*/_jsxs("p", {
          className: "small my-2",
          children: [nodes.length, " assignments / ", nodes.filter(n => n.location && !n.location.stale).length, " with recent GPS / ", nodes.filter(n => !n.location || n.location.stale).length, " awaiting a location update"]
        }), /*#__PURE__*/_jsx(Form.Label, {
          htmlFor: "tracking-search",
          children: "Find a cab, driver or delivery"
        }), /*#__PURE__*/_jsx(Form.Control, {
          id: "tracking-search",
          type: "search",
          value: filter,
          onChange: e => {
            setFilter(e.target.value);
            setSelected('');
            setSharing(false);
          },
          placeholder: "Search name, vehicle, status or trip reference"
        }), filter && /*#__PURE__*/_jsx(Button, {
          variant: "outline-secondary",
          className: "my-2",
          onClick: () => setFilter(''),
          children: "Clear search"
        }), (data === null || data === void 0 ? void 0 : data.lockedCount) > 0 && /*#__PURE__*/_jsxs(Alert, {
          variant: "warning",
          children: ["Some assignments require the rental owner to upgrade to Professional for Google Maps tracking. ", /*#__PURE__*/_jsx("a", {
            href: "/pricing",
            children: "View plans"
          })]
        }), (data === null || data === void 0 ? void 0 : data.truncated) && /*#__PURE__*/_jsx(Alert, {
          variant: "warning",
          children: "Showing the first 200 active assignments. Some fleet items are not on this map."
        }), data && !data.nodes.length && !data.lockedCount && /*#__PURE__*/_jsx(Alert, {
          variant: "info",
          children: "No active cab or delivery assignments today. Location directions remain available from listing and booking maps."
        }), /*#__PURE__*/_jsx(Form.Label, {
          htmlFor: "tracking-trip",
          className: "mt-3",
          children: "Cab / trip to track"
        }), data && filter && !visible.length && /*#__PURE__*/_jsx("p", {
          role: "status",
          children: "No assignments match your search."
        }), /*#__PURE__*/_jsxs(Form.Select, {
          style: {
            minHeight: 44
          },
          id: "tracking-trip",
          className: "mb-3",
          value: selected,
          onChange: e => {
            var n = data === null || data === void 0 ? void 0 : data.nodes.find(x => "".concat(x.kind, ":").concat(x.id) === e.target.value);
            if (n) choose(n);else {
              setSelected('');
              setSharing(false);
            }
          },
          children: [/*#__PURE__*/_jsx("option", {
            value: "",
            children: "Show all authorized cabs / agents"
          }), visible.map(n => /*#__PURE__*/_jsxs("option", {
            value: "".concat(n.kind, ":").concat(n.id),
            children: [n.label, " \xB7 ", n.status, " \xB7 ", n.id.slice(-6), !n.location ? ' · awaiting GPS' : n.location.stale ? ' · stale GPS' : '']
          }, "".concat(n.kind, ":").concat(n.id)))]
        }), open && mapConfig && (!(data !== null && data !== void 0 && data.lockedCount) || (data === null || data === void 0 ? void 0 : data.nodes.length) > 0) && /*#__PURE__*/_jsx(GoogleMapCanvas, {
          apiKey: mapConfig.apiKey,
          mapId: mapConfig.mapId,
          nodes: current ? [current] : visible,
          route: displayedRoute,
          stops: (displayedRoute === null || displayedRoute === void 0 ? void 0 : displayedRoute.status) === 'OK' ? displayedRoute.stops : current && !current.liveEnabled ? [{
            label: 'Pickup',
            address: current.pickup
          }, {
            label: 'Drop',
            address: current.drop
          }].filter(s => s.address) : [],
          polylines: (displayedRoute === null || displayedRoute === void 0 ? void 0 : displayedRoute.status) === 'OK' ? displayedRoute.polylines : [],
          onSelect: choose
        }), open && !mapConfig && /*#__PURE__*/_jsx("p", {
          role: "status",
          children: "Loading map configuration\u2026"
        }), current && /*#__PURE__*/_jsxs("div", {
          className: "mt-3",
          children: [/*#__PURE__*/_jsxs("h5", {
            children: [current.label, " ", /*#__PURE__*/_jsx(Badge, {
              bg: "secondary",
              children: statusText(current.status)
            })]
          }), /*#__PURE__*/_jsxs("p", {
            className: "small",
            children: ["GPS: ", (_current$location = current.location) !== null && _current$location !== void 0 && _current$location.at ? new Date(current.location.at).toLocaleString() : 'Not received', (_current$location2 = current.location) !== null && _current$location2 !== void 0 && _current$location2.stale ? ' — stale; waiting for driver update' : '']
          }), !current.liveEnabled && /*#__PURE__*/_jsxs(Alert, {
            variant: "info",
            children: ["Professional map snapshot. Ask the rental owner to upgrade to Premium for live GPS, traffic ETA and route suggestions. ", /*#__PURE__*/_jsx("a", {
              href: "/pricing",
              children: "View plans"
            })]
          }), current.canShare && /*#__PURE__*/_jsx(Button, {
            size: "sm",
            variant: sharing ? 'danger' : 'outline-primary',
            onClick: () => {
              lastSent.current = 0;
              sharingAssignment.current = current.assignmentKey;
              setSharing(s => !s);
            },
            children: sharing ? 'Stop sharing location' : 'Share my trip location'
          }), gpsMessage && /*#__PURE__*/_jsx("p", {
            role: "status",
            className: "small mt-2",
            children: gpsMessage
          }), current.canOptimize && /*#__PURE__*/_jsx(Form.Check, {
            id: "tracking-optimize",
            className: "my-2",
            checked: optimize,
            onChange: e => setOptimize(e.target.checked),
            label: "Suggest an efficient pickup order where schedule constraints allow"
          }), routeLoading && /*#__PURE__*/_jsx("p", {
            role: "status",
            children: "Calculating traffic distance and arrival..."
          }), routeStale && /*#__PURE__*/_jsx(Alert, {
            variant: "warning",
            children: "The route estimate is out of date. Waiting for fresh GPS and traffic information."
          }), /*#__PURE__*/_jsx(TrackingDetails, {
            node: current,
            route: displayedRoute
          }), routeError && /*#__PURE__*/_jsx(Alert, {
            variant: "danger",
            children: routeError
          }), route && route.status !== 'OK' && /*#__PURE__*/_jsx(Alert, {
            variant: "warning",
            children: reasons[route.status] || 'Route information is unavailable.'
          }), (displayedRoute === null || displayedRoute === void 0 ? void 0 : displayedRoute.status) === 'OK' && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsxs("h6", {
              children: ["Estimated ", route.target === 'pickup' ? 'pickup arrival' : route.target === 'drop' ? 'drop arrival' : 'remaining run', ": ", Math.ceil(route.durationSeconds / 60), " min \xB7 ", (route.distanceMeters / 1000).toFixed(1), " km"]
            }), /*#__PURE__*/_jsxs("p", {
              className: "small",
              children: ["Traffic estimate as of ", new Date(route.computedAt).toLocaleTimeString(), ". Waiting and boarding time can change arrival."]
            }), /*#__PURE__*/_jsx("p", {
              className: "small",
              children: route.guidance
            }), /*#__PURE__*/_jsx("ol", {
              children: route.stops.map((s, i) => /*#__PURE__*/_jsxs("li", {
                children: [s.label, " \xB7 ", pointText(s.address), " \xB7 ", distanceText(s.remainingMeters), " / ", durationText(s.etaSeconds), " / arrival ", arrivalText(route.computedAt, s.etaSeconds)]
              }, i))
            })]
          }), pointText(destination) && /*#__PURE__*/_jsx("a", {
            className: "btn btn-primary mt-2",
            href: navigationUrl(destination),
            target: "_blank",
            rel: "noreferrer",
            children: "Open navigation to next stop"
          })]
        })]
      }), /*#__PURE__*/_jsx(Modal.Footer, {
        children: /*#__PURE__*/_jsx(Button, {
          variant: "secondary",
          onClick: () => {
            setOpen(false);
            setSharing(false);
          },
          children: "Close map"
        })
      })]
    })]
  });
}